<svg
  width="40"
  height="41"
  viewBox="0 0 40 41"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path fill="currentColor" d="M36.0001 36.9C36.0001 35.7679 35.1045 34.85 34.0001 34.85H31.7209L34.1441 27.3982L30.4781 23.6406C32.6437 21.5815 34.0001 18.6413 34.0001 15.375C34.0001 9.14776 29.0754 4.09998 23.0001 4.09998C16.9247 4.09998 12.0001 9.14776 12.0001 15.375C12.0001 18.6411 13.3564 21.5817 15.5217 23.6406L12.7297 26.5019L4 23.5195V30.7499C5.10443 30.7499 6 29.8319 6 28.6999V26.3637L13.27 28.8479L17.1197 24.902C18.8208 26.0069 20.837 26.6498 23 26.6498C25.163 26.6498 27.1793 26.0069 28.8803 24.9016L31.856 27.9516L28.946 36.8999L36.0001 36.9ZM24.0001 16.4H18.0001V14.35H22.0001V8.19998H24.0001V16.4Z" />
</svg>